import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import th from 'date-fns/esm/locale/th';
import { UtilityService } from '../../../core/services/utility.service';
import { SmDataService } from '../../../pages/sm/services/sm-data.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'app-close-out-modal',
  templateUrl: './close-out-modal.component.html',
  styleUrls: ['./close-out-modal.component.css'],
})
export class CloseOutModalComponent implements OnInit {
  @Input() emailToList: any;
  @Input() emailCCList: any;
  @Input() fullEmailList: any;
  @Input() disableEmailOnComplete: any;
  fullEmailListFiltered: any = [];
  count = 0;
  tempEmail = '';
  formData: { [key: string]: any };
  emailInvalid = false;
  emailExist = false;

  constructor(
    private ngbActiveModal: NgbActiveModal,
    private smDataService: SmDataService,
    private utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    this.formData = {};
    this.formData.emailDistribution = '';
    this.formData.emailToList = [];
    this.formData.emailCCList = [];

    if (this.emailToList != null) {
      this.fullEmailList.forEach((val, key) => {
        this.count = 0;
        this.emailToList.forEach((val2, key2) => {
          if (val.Email != null && val2.signedOffSelected != null && val.Email == val2.signedOffSelected.Email) {
            this.count++;
          }
        });
        if (this.count == 0) {
          this.fullEmailListFiltered.push(val);
        }
      });
    }

    if (this.emailToList != null) this.formData.emailToList = cloneDeep(this.emailToList);
    if (this.emailCCList != null) this.formData.emailCCList = cloneDeep(this.emailCCList);
  }

  public emailRegexCheck() {
    var testRegex = new RegExp('^(([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4},)*([a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}))?$');
    if (testRegex.test(this.formData.emailDistribution)) {
      this.emailInvalid = false;
    } else {
      this.emailInvalid = true;
    }
  }

  public checkEmail() {
    var count = 0;
    this.formData.emailCCList.forEach((val, key) => {
      if (val.Email == this.formData.selectedEmail.Email) {
        count++;
      }
    });
    if (count == 0) this.emailExist = false;
    else this.emailExist = true;
  }

  public addToEmailList() {
    this.formData.emailCCList.push({ Email: this.formData.selectedEmail.Email, NewAdded: true });
    this.formData.selectedEmail = null;
  }

  public removeEmail(index) {
    this.formData.emailCCList.splice(index, 1);
  }

  public completeClicked() {
    if (!this.disableEmailOnComplete) {
      this.formData.emailToList.forEach((val, key) => {
        if (val.selectedEmployees) {
          if (val.signedOffSelected != null && val.signedOffSelected.HQContactID != -1) this.tempEmail += val.signedOffSelected.Email + ',';
          else {
            this.tempEmail += val.email + ',';
          }
        }
      });
      if (this.formData.emailDistribution.length > 0) this.tempEmail += this.formData.emailDistribution;
    }
    this.smDataService.emailCCList = this.formData.emailCCList;
    this.ngbActiveModal.close({ extraEmailList: this.tempEmail });
  }

  public cancelClicked() {
    this.ngbActiveModal.dismiss();
  }
}
